const FORMAT_EXTENSION = {
  xlsx: "xlsx",
  csv: "csv",
  json: "json",
  xml: "xml",
};

/**
 * Parses Content-Disposition for a download filename.
 * Supports `filename="..."` and RFC 5987 `filename*=UTF-8''...`.
 */
export const parseFilenameFromContentDisposition = (header) => {
  if (!header || typeof header !== "string") {
    return null;
  }

  const starMatch = /filename\*\s*=\s*(?:UTF-8''|utf-8'')([^;]+)/i.exec(header);
  if (starMatch?.[1]) {
    try {
      return decodeURIComponent(starMatch[1].trim().replace(/^"|"$/g, ""));
    } catch {
      return starMatch[1].trim().replace(/^"|"$/g, "");
    }
  }

  const plainMatch = /filename\s*=\s*("?)([^";]+)\1/i.exec(header);
  if (plainMatch?.[2]) {
    return plainMatch[2].trim();
  }

  return null;
};

export const fallbackExportFileName = (format = "xlsx") => {
  const ext = FORMAT_EXTENSION[format] || "xlsx";
  return `saldos_breakage.${ext}`;
};

export const resolveExportFileName = (contentDisposition, format) =>
  parseFilenameFromContentDisposition(contentDisposition) ||
  fallbackExportFileName(format);

/**
 * Triggers a browser download for a Blob and revokes the object URL.
 */
export const downloadBlob = (blob, fileName) => {
  if (typeof window === "undefined" || !blob) {
    return;
  }

  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName || fallbackExportFileName();
  anchor.style.display = "none";
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.URL.revokeObjectURL(url);
};
